import _sfc_main from "/opt/buildhome/repo/src/App.vue?vue&type=script&setup=true&lang.ts";
export * from "/opt/buildhome/repo/src/App.vue?vue&type=script&setup=true&lang.ts";
import "/opt/buildhome/repo/src/App.vue?vue&type=style&index=0&scoped=66dd596d&lang.css";
import _export_sfc from "\0plugin-vue:export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-66dd596d"]]);
